import React, { useEffect, useState } from "react";
import HomeCard from "./HomeCard";
import "./Home.css";
import ChartBox from "./ChartBox";
import PieChartsBox from "./PieChartsBox";
import styles from "./Index.module.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useNavigate } from "react-router-dom";
import HomeServices from "../../Services/HomeServices";
import toast from "react-hot-toast";

const Index = () => {
  const [value, setValue] = useState(new Date());
  const [calenderConvertedValue, setCalenderConvertedValue] = useState(
    formatToMonthYear(new Date().toString()),
  );
  const [fetchCalenderReminderLoading, setFetchCalenderReminderLoading] =
    useState(false);
  const [calenderReminders, setCalenderReminders] = useState([]);
  const [digitDatas, setDigitDatas] = useState({});
  const navigate = useNavigate();

  //old function
  // const formatDate = (date) => date.toISOString().split("T")[0];

  //new function
  const formatDate = (date) => {
    // Use UTC to avoid timezone issues
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const fetchCalenderReminder = async () => {
    try {
      setFetchCalenderReminderLoading(true);
      const response = await HomeServices.getAllCalenderReminderForDashboard();
      console.log("Calender DashBoard", response);
      if (response?.status) {
        filterReminderByMonthYear(response?.data);
        setCalenderReminders(response?.data);
        setFetchCalenderReminderLoading(false);
      } else {
        toast.error("Error fetching calender data");
        setFetchCalenderReminderLoading(false);
      }
    } catch (error) {
      toast.error(error);
      setFetchCalenderReminderLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    fetchCalenderReminder();
  }, [calenderConvertedValue]);

  function formatToMonthYear(dateString) {
    const date = new Date(dateString);
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    return `${month} ${year}`;
  }

  // old function
  // function formatDateObjectToYYYYMMDD(date) {
  //   let year = date.getFullYear();
  //   let month = date.getMonth() + 1; // 1–12
  //   let dayNum = date.getDate() - 1;

  //   if (dayNum === 0) {
  //     const prevMonthLastDate = new Date(year, month - 1, 0);
  //     year = prevMonthLastDate.getFullYear();
  //     month = prevMonthLastDate.getMonth() + 1;
  //     dayNum = prevMonthLastDate.getDate();
  //   }

  //   const monthStr = String(month).padStart(2, "0");
  //   const dayStr = String(dayNum).padStart(2, "0");

  //   return `${year}-${monthStr}-${dayStr}`;
  // }

  //new function
  function formatDateObjectToYYYYMMDD(date) {
    // Work with UTC to ensure consistency
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth() + 1;
    let dayNum = date.getUTCDate();

    // Subtract one day in UTC
    const utcDate = new Date(Date.UTC(year, month - 1, dayNum));
    utcDate.setUTCDate(utcDate.getUTCDate() - 1);

    year = utcDate.getUTCFullYear();
    month = utcDate.getUTCMonth() + 1;
    dayNum = utcDate.getUTCDate();

    const monthStr = String(month).padStart(2, "0");
    const dayStr = String(dayNum).padStart(2, "0");

    return `${year}-${monthStr}-${dayStr}`;
  }

  let obj = {};
  const filterReminderByMonthYear = (arr) => {
    // const presentMonthYear = formatToMonthYear(new Date().toString());
    console.log("present month and year", calenderConvertedValue);
    const newArr = arr?.filter((e, i) => {
      // console.log(e, presentMonthYear);
      // return presentMonthYear == formatToMonthYear(e?.calenderDate.toString());
      console.log(
        calenderConvertedValue == formatToMonthYear(e?.calenderDate.toString()),
      );
      return (
        calenderConvertedValue == formatToMonthYear(e?.calenderDate.toString())
      );
    });

    console.log("New Array", newArr);

    newArr.forEach((e) => {
      obj = {
        ...obj,
        [formatDateObjectToYYYYMMDD(new Date(e?.calenderDate)).toString()]:
          e?.notesCount,
        // [e?.calenderDate]: e?.notesCount,
      };
    });
    console.log("obj", obj);
    setDigitDatas({ ...obj });
    // setCalenderReminders(newArr);
    console.log("Year and month", newArr);
  };

  function formatMonthYearString(ymStr) {
    if (!ymStr) return "";

    const [year, month] = ymStr.split("-");
    const date = new Date(`${year}-${month}-01`);

    const formatted = date.toLocaleString("en-US", {
      month: "long",
      year: "numeric",
    });

    return formatted;
  }

  return (
    <>
      <div className="main_wrap">
        {/* <div className="container-fluid"> */}
        <HomeCard />
        <div className={styles.calenderDesign}>
          {console.log("digit datas", digitDatas)}
          {/* {console.log("digit data", digitData)} */}
          {fetchCalenderReminderLoading ? (
            <div>Loading...</div>
          ) : (
            <Calendar
              showNeighboringMonth={false}
              minDetail="month" // ✨ এটাই সবচেয়ে গুরুত্বপূর্ণ
              maxDetail="month"
              className={`${styles.calenderitself} `}
              value={value}
              // value={null}
              // --------- to disable month change ---------
              // prevLabel={null}
              // nextLabel={null}
              // next2Label={null}
              // prev2Label={null}

              onActiveStartDateChange={({ activeStartDate, view }) => {
                const year = activeStartDate.getFullYear();
                const month = activeStartDate.getMonth() + 1; // 0-indexed
                console.log("active start date", activeStartDate);
                // fetchCalenderReminder();
                // setValue(`${year}-${month}`);

                setCalenderConvertedValue(
                  formatMonthYearString(`${year}-${month}`),
                );
                setValue(activeStartDate);

                console.log("Calendar changed to:", `${year}-${month}`);
                console.log("Current view is:", view); // "month", "year", "decade", etc.
              }}
              // old function
              // onClickDay={(date) => {
              //   const dateStr = formatDate(date); // e.g. "2025-07-14"
              //   if (digitDatas[dateStr]) {
              //     navigate("/calendar-reminder", {
              //       state: {
              //         date: date,
              //         reminder: calenderReminders,
              //       },
              //     });
              //   }
              // }}

              //new function
              onClickDay={(date) => {
                // Use UTC date to ensure consistency
                const dateStr = formatDate(date);
                if (digitDatas[dateStr]) {
                  navigate("/calendar-reminder", {
                    state: {
                      date: date,
                      reminder: calenderReminders,
                    },
                  });
                }
              }}
              tileContent={({ date, view }) =>
                view === "month" && digitDatas[formatDate(date)] ? (
                  <div
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      color: "blue",
                    }}
                  >
                    {digitDatas[formatDate(date)]}
                  </div>
                ) : null
              }
            />
          )}
        </div>
        {/* </div> */}
      </div>
    </>
  );
};

export default Index;
